var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('banner',{staticClass:"hospital-info-banner",attrs:{"message":_vm.bannerMessage}})}
var staticRenderFns = []

export { render, staticRenderFns }